module.exports = __webpack_public_path__ + "static/media/research_outreach.e08739fb.png";